import { combineReducers } from 'redux';
import authReducer from './authReducer';
import errorReducer from './errorReducer';
import systemMessagesReducer from './systemMessagesReducer';

export default combineReducers({
    auth: authReducer,
    errors: errorReducer,
    systemMessages: systemMessagesReducer,
});
